import { axios } from './config';

export const getAllSites = () => {
	return axios.get('/bannerfp/all');
};

export const getBannerFpConfigForSite = (siteId) => {
	return axios.get(`/bannerfp/${siteId}`);
};

export const createBannerFpConfig = (payload) => {
	return axios.post('/bannerfp/create', payload);
};

export const updateBannerFpConfigInDb = (payload) => {
	const siteId = payload.siteId;
	return axios.put(`/bannerfp/${siteId}`, payload);
};

export const syncManualFloors = (payload) => {
	return axios.post(`/bannerfp/sync-manual-floors`, payload);
};
